<template>
		<div class="w1200 intr-list">
			<div class="crumbs">
			<span><a href="#/">首页 ></a></span>
			<span>关于协会</span>
		</div>
			<template v-for="(item,index) in xiehuiList">
				<div class="item">
					<div class="i-l-left"><a :href="'#/NewSInfo/' + item.id " target="_blank">{{item.title}}</a></div>
				    <div class="i-l-right">{{item.create_time | formatDate}}</div>
				</div>
				
			</template>
		</div>
</template>

<script>
	import Vue from 'vue';
	export default {

		data() {
			return {}
		},
		methods: {

		},
		components: {}
	}
</script>

<script>
	import Vue from 'vue';
	import Element from 'element-ui';
	import 'element-ui/lib/theme-chalk/index.css';
	import { formatDate } from '../assets/js/date.js';
	Vue.use(Element, {
		size: 'small',
		zIndex: 3000
	});

	export default {
		filters: { //格式化日期
			formatDate(time) {
				var date = new Date(time);
				return formatDate(date, 'yyyy-MM-dd');
			}
		},
		name: 'HelloWorld',
		data() {
			return {
				path: domain.apiUrl,
				xiehuiList: []
			}
		},
		mounted: function() {
			this.getXiehuiList();
		},
		methods: {

			//协会列表
			getXiehuiList: function() {
				this.$http.get(this.path + 'index/getHeadList?groupId=6').then((response) => {
					if(response.status === 200) {
						var data = response.body;
						this.xiehuiList = data.newsList;
					} else {
						this.$message.error("error")
					}

				}, (response) => {

				});
			}
		}
	}
</script>
<style>
	@import "../assets/css/list.css";
</style>


// WEBPACK FOOTER //
// src/components/IntroductionList.vue